import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH. The redirect target is derived dynamically from
// window.location.origin in Login.jsx; this page only EXCHANGES the
// session_id we receive in the URL fragment for our own JWT.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  // Strict-mode-proof: a ref guarantees we don't double-call /session
  // (which would 401 the second time because Emergent's session_id is
  // single-use).
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error("No se recibió el código de sesión de Google.");
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/session`, { session_id });
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        window.dispatchEvent(new Event("subscription-updated"));
        // Clean the fragment so a refresh doesn't try to re-exchange.
        window.history.replaceState({}, document.title, "/");
        toast.success(`Bienvenido, ${data.user?.name || data.user?.email}`);
        navigate("/", { replace: true });
      } catch (err) {
        const det = err.response?.data?.detail;
        toast.error(typeof det === "string" ? det : "No se pudo completar el inicio de sesión con Google.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#F9F9FA]"
      data-testid="google-auth-callback-screen"
    >
      <div className="text-center">
        <div className="inline-block animate-spin h-8 w-8 border-2 border-[rgb(0,47,167)] border-t-transparent rounded-full mb-3" />
        <p className="text-sm text-slate-600">Completando inicio de sesión con Google...</p>
      </div>
    </div>
  );
}
